import ShorcutsCardList from './ShorcutsCardList';

export default ShorcutsCardList;
